import PreQuestion from './../components/PrepInterview/PreQuestion';

import { Helmet } from 'react-helmet';


export const metadata = {
  title: 'Applicant Assessment',
  description: 'Human Resource management and workflow platform to help organize data and business workflow.',
  openGraph: {
    title: 'Applicant Assessment',
    description: 'Human Resource management and workflow platform to help organize data and business workflow.',
    url: 'https://blog.formerly.com',
    siteName: 'Formerly',
    images: [
      {
        url: 'https://testguard.fomerly.com/assets/images/og-image.jpg',
        width: 1200,
        height: 630,
        alt: 'Formerly HR Management Platform'
      }
    ],
    type: 'website'
  },
  twitter: {
    card: 'summary_large_image',
    title: 'Applicant Assessment',
    description: 'Human Resource management and workflow platform to help organize data and business workflow.',
    images: ['https://testguard.fomerly.com/assets/images/twitter-card.jpg']
  },
  metadataBase: new URL('https://testguard.fomerly.com'),
  alternates: {
    canonical: 'https://blog.formerly.com'
  },
  other: {
    'msapplication-TileColor': '#ffffff',
    'theme-color': '#ffffff',
    'robots': 'index, follow',
    'viewport': 'width=device-width, initial-scale=1',
    'keywords': 'HR management, Applicant platform, workflow, business organization, HR tools'
  },
  icons: {
    icon: '/favicon.ico',
    apple: '/apple-touch-icon.png'
  }
};

export default function Home() {
  return (
    <>
      <Helmet>
        <title>Applicant Assessment </title>
        <meta name="description" content="Human Resource management and workflow platform to help organize data and business workflow." />
        <meta name="keywords" content="HR management, Applicant platform, workflow, business organization, HR tools" />
        <meta name="robots" content="noindex, nofollow" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Applicant Assessment" />
        <meta property="og:description" content="Human Resource management and workflow platform to help organize data and business workflow." />
        <meta property="og:url" content="https://testguard.fomerly.com" />
        <meta property="og:image" content="https://testguard.fomerly.com/assets/images/og-image.jpg" />
        <meta property="og:type" content="website" />
        
        {/* Twitter */}
        <meta name="twitter:title" content="Applicant Assessment" />
        <meta name="twitter:description" content="Human Resource management and workflow platform to help organize data and business workflow." />
        <meta name="twitter:image" content="https://testguard.fomerly.com/assets/images/twitter-card.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        
        {/* Canonical Link */}
        <link rel="canonical" href="https://blog.formerly.com" />
        
        {/* Favicon and Touch Icons */}
        <link rel="icon" href="/favicon.ico" />
        <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
        
        {/* Verification Codes */}
        <meta name="google-site-verification" content="your-google-site-verification-code" />
        <meta name="msvalidate.01" content="your-bing-verification-code" />
        
        {/* JSON-LD Schema Markup */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "url": "https://testguard.fomerly.com",
            "name": "Applicant Assessment",
            "description": "Human Resource management and workflow platform to help organize data and business workflow.",
            "publisher": {
              "@type": "Organization",
              "name": "Formerly",
              "logo": {
                "@type": "ImageObject",
                "url": "https://testguard.fomerly.com/assets/images/logo.png"
              }
            }
          })}
        </script>
      </Helmet>
      <div className="flex flex-col items-center justify-center min-h-screen p-8 gap-8">
        
<br />
<br />
      <section className="Hero-sect-full bg-white py-12 md:py-20">
 
 <PreQuestion />
</section>
       



      </div>
    </>
  );
}
